import React from 'react';
import { View, StyleSheet } from 'react-native';

import { Text, IconButton, useTheme } from '@/components/ui';

interface ErrorBannerProps {
	message?: string | null;
	error?: Error | null;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({ message, error }) => {
	const theme = useTheme();
	const msg = message || error?.message;
	if (!msg) return null;
	return (
		<View style={[styles.container, { borderColor: theme.colors.error, backgroundColor: theme.colors.errorContainer }]}>
			<IconButton icon="alert-circle" iconColor={theme.colors.error} size={20} style={{ margin: 0 }} />
			<Text style={[styles.text, { color: theme.colors.error }]}>{msg}</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		alignItems: 'center',
		paddingVertical: 8,
		paddingHorizontal: 12,
		borderWidth: 1,
		borderRadius: 6,
		marginBottom: 12,
	},
	text: {
		fontSize: 14,
		fontWeight: '400',
	},
});

